var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 7 2 C 5.34375 2 4 3.34375 4 5 L 4 16.84375 C 4 18.53125 5.332031 19.921875 7 20 L 6 21 L 6 22 L 18 22 L 18 21 L 17 20 C 18.667969 19.921875 20 18.53125 20 16.84375 L 20 5 C 20 3.34375 18.65625 2 17 2 Z M 9 4 L 15 4 L 15 5 L 9 5 Z M 6 7 L 11 7 L 11 12 L 6 12 Z M 13 7 L 18 7 L 18 12 L 13 12 Z M 7.5 15 C 8.328125 15 9 15.671875 9 16.5 C 9 17.328125 8.328125 18 7.5 18 C 6.671875 18 6 17.328125 6 16.5 C 6 15.671875 6.671875 15 7.5 15 Z M 16.5 15 C 17.328125 15 18 15.671875 18 16.5 C 18 17.328125 17.328125 18 16.5 18 C 15.671875 18 15 17.328125 15 16.5 C 15 15.671875 15.671875 15 16.5 15 Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.3bf174515651ef2e9880077297a86ab3.svg";
export { ForwardRef as ReactComponent };